function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M35.5 51.895l26.526-12.2-26.526-1.1-26.526 1.1z",
  fill: "#fcbf91"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.965 17.207v18.72h31.903V6.616L35.6 3.96z",
  fill: "#9d5125"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M35.6 67.96l26.526-18.818-26.6-3.887-26.56 3.887z",
  fill: "#fcbf91"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "#9d5125"
}, /*#__PURE__*/React.createElement("path", {
  d: "M35.6 17.24v18.688h14.024v-19.95L45.5 14.324z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.5 23.36v12.567h10.85V22.972l-3.1-.907z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.24 21.03v14.9h8.777l.097-14.964-2.656-1.07z"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M40.868 35.928V6.616L35.6 3.96v31.968zm8.745 0v-19.95L45.5 14.324v21.603zm6.737 0V22.972l-3.1-.907v13.862zm3.1 0V19.895l2.656 1.07V35.93zm2.568 3.757v5.603L35.5 51.895V42.34zm.097 14.963v-5.506L35.5 58.535v9.425z",
  fill: "#f58532"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M8.965 54.713v-5.57L35.5 58.47v9.5zm0-9.425v-5.603L35.5 42.34v9.555z",
  fill: "#9d5125"
});

const SvgKinesis = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "3.54 3.96 64 64",
  width: 64,
  height: 64,
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgKinesis, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/kinesis.c6d279da.svg";
export { ForwardRef as ReactComponent };